import PropTypes from 'prop-types';
import React from 'react';
import { locationShape } from 'react-router/lib/PropTypes';

import App from '../../../src/components/App';

const DelayRepayApp = ({ children, location, ...restProps }) => (
    <App location={ location } { ...restProps }>{ children }</App>
);

DelayRepayApp.propTypes = {
    location: locationShape.isRequired,
    children: PropTypes.element.isRequired
};

export default DelayRepayApp;
